import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function getLoginSubtitle({ forgotPassword, forgotUsername, needs2FA }) {
  if (forgotPassword) return "Reset your password";
  if (forgotUsername) return "Recover your username";
  if (needs2FA) return "Enter your verification code";
  return "Sign in to your account";
}

const LoginFormHeader = ({
  forgotPassword,
  forgotUsername,
  needs2FA,
  setNeeds2FA,
  setPassword,
  handleBackToLogin,
  primaryColor,
}) => (
  <>
    <Box sx={{ textAlign: "center", mb: 2 }}>
      {(forgotPassword || forgotUsername || needs2FA) && (
        <Box
          sx={{
            position: "absolute",
            top: 40,
            left: 0,
            "@media (max-width: 768px)": {
              left: -10,
            },
          }}
        >
          <IconButton
            onClick={() => {
              if (needs2FA) {
                setNeeds2FA(false);
                setPassword("");
              } else {
                handleBackToLogin();
              }
            }}
            sx={{
              color: primaryColor,
              backgroundColor: "rgba(51, 51, 51, 0.1)",
              "&:hover": {
                backgroundColor: "rgba(51, 51, 51, 0.2)",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>
      )}
    </Box>

    {/* Welcome Section */}
    <Box sx={{ textAlign: "center", mb: 2 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: primaryColor,
          mb: 0.5,
          fontSize: { xs: "1.6rem", sm: "1.8rem" },
        }}
      >
        Welcome Back
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          fontSize: "1rem",
          fontWeight: 400,
        }}
      >
        {getLoginSubtitle({ forgotPassword, forgotUsername, needs2FA })}
      </Typography>
    </Box>
  </>
);

export default LoginFormHeader;
